export const CONGRESS_LEYEND =
  '* SUMAR compara con la suma de escaños de Podemos y Más País.';

export const SENATE_LEYEND =
  '* IZQUIERDAS POR LA INDEPENDENCIA es la coalición de ERC y EH-Bildu';

export const UPDATE_CERA =
  '*El número total de votos, pendiente de actualización del voto CERA.';
